import { render, staticRenderFns } from "./detailImportList.vue?vue&type=template&id=3c5df37a&scoped=true&"
import script from "./detailImportList.vue?vue&type=script&lang=js&"
export * from "./detailImportList.vue?vue&type=script&lang=js&"
import style0 from "./detailImportList.vue?vue&type=style&index=0&id=3c5df37a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5df37a",
  null
  
)

export default component.exports